import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { Grid, Column, actionCell, dateCell, iconCell, enumCell } from 'components/grid'
import { localized } from 'decorators'
import { holdingStrategy } from 'enums/holdingStrategy'
import { loweIndex } from 'enums/loweIndex'
import { storageStatus } from 'enums/storageStatus'
import { soldByChannel } from 'enums/soldByChannel'

export default connect(
  ({ bottlesFilter, bottles }) => ({ bottlesFilter, bottles }))(localized(({ bottlesFilter, dataSource, metadata, onRowClick, localize, actionProps, persistor, isTrash, bottles }) => {
  const actionCellProps = {
    actionProps,
    nameGetter: x => x.wineName,
    isSoftDelete: metadata.isSoftDelete,
    hideDelete: metadata.hideDelete
  }
  //const onExport = useCallback(() => startExport({ id: bottlesFilter.entity.id }), [startExport, bottlesFilter.entity.id])
  return (
    <Grid
        dataSource={dataSource}
        onRowClick={onRowClick}
        filterable={false}
        persistor={persistor}
        multiselect={true}
        canExport={false}
        isExporting={bottles.exporting}
        //onExport={onExport}
        pageSizes={[5, 10, 20, 50, 100]}
        staticFilters={isTrash ? [] : bottlesFilter.staticFilter}>
        <Column field='wineName' title={localize('bottles.wineName')} cell={iconCell({ icon: metadata.icon })} width={450} />
        <Column field='winery' title={localize('bottles.winery')} width={200} />
        <Column field='quality' title={localize('bottles.quality')} filter='numeric' width={100} />
        <Column field='expiration' title={localize('bottles.expiration')} filter='numeric' width={120} />
        <Column field='storagePlaceName' title={localize('bottles.storagePlace')} width={170} />
        <Column field='storageLocation' title={localize('bottles.storageLocation')} width={170} />
        <Column field='supplierName' title={localize('bottles.supplierName')} width={150} />
        <Column field='dateOfOrder' title={localize('bottles.dateOfOrder')} cell={dateCell()} width={180} />
        <Column field='dateOfArrival' title={localize('bottles.dateOfArrival')} cell={dateCell()} width={180} />
        <Column field='dateOfSale' title={localize('bottles.dateOfSale')} cell={dateCell()} width={180} />
        <Column field='expQuality' title={localize('bottles.expQuality')} filter='numeric' width={130} />
        <Column field='holdingStrategy' title={localize('bottles.holdingStrategy')} cell={enumCell({ enum: holdingStrategy })} width={150} />
        <Column field='status' title={localize('bottles.status')} cell={enumCell({ enum: storageStatus })} width={150} />
        <Column field='soldByChannel' title={localize('bottles.soldByChannel')} cell={enumCell({ enum: soldByChannel })} width={150} />
        <Column field='regionName' title={localize('bottles.region')} width={150} />
        <Column field='countryName' title={localize('bottles.country')} width={150} />
        <Column field='districtName' title={localize('bottles.district')} width={150} />
        <Column field='subdistrictName' title={localize('bottles.subdistrict')} width={150} />

        <Column cell={actionCell(actionCellProps)} width={100} filterable={false} sortable={false} />
    </Grid>
  )
}))